import { render, staticRenderFns } from "./RegionDynamics.vue?vue&type=template&id=df5c80e8&"
import script from "./RegionDynamics.vue?vue&type=script&lang=js&"
export * from "./RegionDynamics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports